import {FC} from 'react';

type Icon = {
    className?: string;
};

const NewWarning: FC<Icon> = ({className}) => (
    <svg
        width="22"
        height="25"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M0.787097 19.2C0.494624 19.2 0.270968 19.0685 0.116129 18.8055C-0.0387097 18.5425 -0.0387097 18.2795 0.116129 18.0164L10.129 0.394521C10.2839 0.131507 10.5075 0 10.8 0C11.0925 0 11.3161 0.131507 11.471 0.394521L21.4839 18.0164C21.6387 18.2795 21.6387 18.5425 21.4839 18.8055C21.329 19.0685 21.1054 19.2 20.8129 19.2H0.787097ZM10.9032 7.31178C10.6796 7.31178 10.4946 7.3863 10.3484 7.53534C10.2021 7.68438 10.129 7.87288 10.129 8.10082V12.4142C10.129 12.6422 10.2021 12.8307 10.3484 12.9797C10.4946 13.1288 10.6796 13.2033 10.9032 13.2033C11.1269 13.2033 11.3118 13.1288 11.4581 12.9797C11.6043 12.8307 11.6774 12.6422 11.6774 12.4142V8.10082C11.6774 7.87288 11.6043 7.68438 11.4581 7.53534C11.3118 7.3863 11.1269 7.31178 10.9032 7.31178ZM10.9032 16.1227C11.1269 16.1227 11.3118 16.0482 11.4581 15.8992C11.6043 15.7501 11.6774 15.5616 11.6774 15.3337C11.6774 15.1058 11.6043 14.9173 11.4581 14.7682C11.3118 14.6192 11.1269 14.5447 10.9032 14.5447C10.6796 14.5447 10.4946 14.6192 10.3484 14.7682C10.2021 14.9173 10.129 15.1058 10.129 15.3337C10.129 15.5616 10.2021 15.7501 10.3484 15.8992C10.4946 16.0482 10.6796 16.1227 10.9032 16.1227ZM2.12903 17.6219H19.471L10.8 2.36712L2.12903 17.6219Z"
            fill="#F65858"
        />
    </svg>
);

export default NewWarning;
